import React from 'react'
import { Rating } from 'semantic-ui-react'

const RatingExampleStar = () => (
  <Rating icon='star' defaultRating={5} maxRating={5} />
)

export default RatingExampleStar
